import { ColumnDef } from 'features/common/hooks/useColumnSelection';

// Column story: when → who (entity) → who (contact) → what happened → what bought → extras → how much
// Render order is the `priority` field (useColumnSelection sorts by it), NOT array position.
export const COLUMN_DEFS: ColumnDef[] = [
	{ key: 'date', labelKey: 'ordersPage-table-date-green', minWidth: 220, priority: 1 },
	{ key: 'name', labelKey: 'ordersPage-table-name-green', minWidth: 180, priority: 2 },
	{ key: 'email', labelKey: 'ordersPage-table-email-green', minWidth: 200, priority: 3 },
	{ key: 'status', labelKey: 'ordersPage-table-status', minWidth: 120, priority: 4 },
	// Phone is hidden by default: secondary contact info, only populated when the partner
	// collects it at checkout (phone_collection). Users opt in via the Columns picker.
	{ key: 'phone', labelKey: 'ordersPage-table-phone-green', minWidth: 160, priority: 10, defaultHidden: true },
	{ key: 'ticketType', labelKey: 'ordersPage-table-ticket-type-green', minWidth: 160, priority: 5 },
	{ key: 'addons', labelKey: 'ordersPage-table-addons', minWidth: 160, priority: 6 },
	// Amount (the order total) is the LAST visible column — the row's "bottom line",
	// read after what was bought (ticketType) and any extras (addons).
	{ key: 'price', labelKey: 'ordersPage-table-value-green', minWidth: 120, priority: 7 },
	// Quantity is hidden by default: the count is already explicit in the per-type
	// ticketType breakdown (N× lines) and the per-add-on addons lines, so a standalone
	// Qty column is redundant on first load. Users can re-enable it via the Columns picker.
	{ key: 'quantity', labelKey: 'ordersPage-table-quantity-green', minWidth: 100, priority: 8, defaultHidden: true },
	// Event column is hidden by default on the per-show Transactions page: the
	// show name is already visible in the iframe breadcrumb, so the per-row
	// event value is redundant on first load. Users can re-enable it via the
	// Columns picker if they need it (e.g. multi-event Transactions context).
	{ key: 'event', labelKey: 'ordersPage-table-event', minWidth: 160, priority: 9, defaultHidden: true },
];

export const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

// Non-charging transaction types: an order that took no money (a free registration, or a voided
// order). Both render the "registration" placeholder in the Amount column instead of a dollar figure.
// Named once here because the same closed set is matched in realStatus and the price cell.
export const TRANSACTION_TYPE = {
	REGISTRATION: 'registration',
	VOID: 'void',
} as const;
